
import { Route } from 'vue-router'
import { VueRouter } from 'vue-router/types/router'
import { NavigationButtons } from '@/commons/types'
import { Component, Vue } from 'vue-property-decorator'
import AppNavigation from '@/commons/components/core/AppNavigation.vue'

import ValidDocuments from '@/commons/views/ValidDocuments.vue'

@Component({
    components: {
        AppNavigation,
        ValidDocuments
    }
})
export default class Home extends Vue {
    titleKey = 'applicationChoose.title'

    created (): void {
        document.title = this.$tc('metadata.requestType')
    }

    get navigationButtons (): Array<NavigationButtons> {
        const router = (this.$router as VueRouter & { options: { routes: Array<Route>}})
        if (!router.options || !router.options.routes || router.options.routes.length < 1) {
            return []
        }
        const routes = router.options.routes
        const navigationButtons: Array<NavigationButtons> = []
        for (const route of routes) {
            if (route.meta && route.meta.isMainNavigation && route.meta.buttonTranslationKey && route.path) {
                navigationButtons.push({
                    buttonText: this.$t(`applicationChoose.${route.meta.buttonTranslationKey}`).toString(),
                    path: route.path
                })
            }
        }
        return navigationButtons
    }
}
